import { Checkbox, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import Loader from 'v2/components/Loader/Loader';

export interface Props {
  title: string;
  rulesContent: string;
  rulesName: string;
  isCheckBoxChecked: boolean;
  handleCheckBoxOnClick: () => void;
  isLoading: boolean;
  checkboxId: string;
}

const Rules: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  rulesContent,
  rulesName,
  isCheckBoxChecked,
  handleCheckBoxOnClick,
  isLoading,
  checkboxId
}) => {
  const theme = useTheme();
  return (
    <Stack
      gap={3}
      padding="24px 16px"
      sx={{
        flex: 1,
        minHeight: 0,
        width: 'min(1200px, calc(100vw - 32px))',
        height: 'min(800px, calc(100vh - 32px))'
      }}
    >
      <Typography variant="h4" color="textPrimary">
        {`${title}`}
      </Typography>
      <Stack
        style={{
          flex: '1 1 auto',
          minHeight: 0,
          maxHeight: '60vh',
          border: `1px solid ${theme.custom.borderAndDivider.default}`,
          overflowY: 'auto',
          padding: '16px 64px',
          backgroundColor: theme.palette.secondary.contrastText
        }}
      >
        {isLoading ? (
          <Stack width="100%" height="100%" justifyContent="center" alignItems="center">
            <Loader />
          </Stack>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: rulesContent }} />
        )}
      </Stack>
      <Stack alignSelf="flex-start" gap={1} alignItems="center" justifyContent="center" flexDirection="row">
        <Checkbox id={checkboxId} checked={isCheckBoxChecked} onClick={handleCheckBoxOnClick} color="primary" />
        <Typography variant="body1" color="textPrimary">
          I have read and agree to the terms of the
          <span style={{ fontWeight: 'bold' }}> {rulesName}</span>
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Rules;
